import {ClientFactory} from "@simplify9/simplyapiclient";

export const client = ClientFactory();
